import axios from 'axios'
import VueCookie from 'vue-cookies'

let API_URL = ''

axios.defaults.baseURL = API_URL
axios.defaults.headers.common['contentType'] = 'application/json'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Cache-control'] = 'no-store'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.headers.common['Expires'] = 3600
axios.defaults.headers.common['Timezone'] = new Date().getTimezoneOffset()
axios.defaults.headers.common['X-Request-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookie.get('auth_token')
axios.defaults.headers.common['Accept'] = 'application/json,multipart/form-data'

export default {
  request(method, url, params, data, headers = {}, config = {}) {
    return axios.request({ ...config, url, params, data, method: method.toLowerCase(), headers })
  },

  get(url, params, config = {}) {
    return this.request('get', url, params, {}, {}, config)
  },

  post(url, data, headers = {}) {
    return this.request('post', url, {}, data, headers)
  },

  put(url, data) {
    return this.request('put', url, {}, data)
  },

  delete(url, data = {}) {
    return this.request('delete', url, {}, data)
  },

  refresh(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  },
}
